import { r as registerInstance, h, H as Host, g as getElement } from './index-8f7fb048.js';

const marketToasterCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}:host{position:fixed;right:0;bottom:0;left:0;z-index:3;padding:0 0 var(--toast-bottom-margin, 24px);pointer-events:none}:host ::slotted(.market-toast){width:calc(100% - var(--toast-horizontal-margin, 16px) * 2);margin:var(--toast-vertical-spacing, 16px) auto 0;pointer-events:auto}:host ::slotted(.use-transitions){position:absolute;top:100%;left:50%;margin:0;transition:transform var(--toast-animation-transition-duration, 200ms) ease-in-out;transform:translate(-50%, 0)}";

// TODO(UI-1153): add design tokens for these
const TOAST_VERTICAL_SPACING = 16;
const TOAST_BOTTOM_MARGIN = 24;
const TOAST_ANIMATION_TRANSITION_DURATION = 200;
const MarketToaster = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.toasts = [];
  }
  /**
   * Add the passed toastEl to market-toaster and make it visible
   **/
  async show(toastEl) {
    this.toasts.unshift(toastEl);
    toastEl.classList.add('use-transitions');
    this.el.appendChild(toastEl);
    window.requestAnimationFrame(this.positionToasts.bind(this));
    await new Promise((resolve) => setTimeout(resolve, TOAST_ANIMATION_TRANSITION_DURATION));
    toastEl.startAutoDismissTimer();
  }
  positionToasts() {
    let offset = TOAST_BOTTOM_MARGIN;
    this.toasts.forEach((toast) => {
      toast.style.transform = `translate(-50%, calc(-100% - ${offset}px))`;
      offset += toast.offsetHeight + TOAST_VERTICAL_SPACING;
    });
  }
  /**
   * Remove the passed toastEl from market-toaster
   **/
  async hide(toastEl) {
    const index = this.toasts.indexOf(toastEl);
    this.toasts.splice(index, 1);
    window.requestAnimationFrame(() => {
      toastEl.style.transform = '';
      this.positionToasts();
    });
    await new Promise((resolve) => setTimeout(resolve, TOAST_ANIMATION_TRANSITION_DURATION));
    toastEl.remove();
  }
  /**
   * Remove all market-toasts from market-toaster
   **/
  removeAll() {
    const allActiveToasts = [...this.toasts];
    return Promise.all(allActiveToasts.map((toast) => this.hide(toast)));
  }
  toastAutoDismissedEventHandler({ target: toast }) {
    this.hide(toast);
  }
  toastManuallyDismissedEventHandler({ target: toast }) {
    this.hide(toast);
  }
  render() {
    return (h(Host, { class: "market-toaster" }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
MarketToaster.style = marketToasterCss;

export { MarketToaster as market_toaster };
